export default __webpack_public_path__ + "static/media/icon_3d.f28ea9cc.svg";